import { BadgeCheck } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Editable } from "@/components/builder/Editable";
import { Star } from "lucide-react";

const TESTIMONIALS = [
  { key: "t1", quote: "Email, PEC e WhatsApp finalmente in un unico posto. L'AI le classifica e apre le pratiche: risparmio ore ogni settimana.", name: "Amministratore di condominio", role: "Studio a Milano · uso verificato" },
  { key: "t2", quote: "Le segnalazioni dei condomini non si perdono più. Rispondiamo più in fretta e con lo stesso tono in tutto lo studio.", name: "Studio di amministrazione", role: "Provincia di Bologna · uso verificato" },
  { key: "t3", quote: "L'agente propone i fornitori giusti quando c'è un'emergenza. Io controllo e approvo: veloce e sotto controllo.", name: "Amministratrice", role: "Studio a Torino · uso verificato" },
  { key: "t4", quote: "Con la ricerca semantica trovo qualsiasi comunicazione in pochi secondi, basta fare una domanda.", name: "Consigliere di condominio", role: "Roma · uso verificato" },
];

const Stars = () => (<div className="mb-3 flex gap-0.5 text-amber-400">{Array.from({ length: 5 }).map((_, i) => (<Star key={i} className="h-4 w-4 fill-current" />))}</div>);

export const Testimonials = () => {
  return (
    <section id="testimonianze" data-testid="testimonials" className="bg-white">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <Editable as="p" path="test.eyebrow" className="mb-3 block text-xs font-bold uppercase tracking-[0.16em] text-primary">Già testato dagli amministratori</Editable>
        <Editable as="h2" path="test.title" className="block max-w-2xl font-display text-4xl font-extrabold text-foreground sm:text-5xl">Amministratori come te lavorano già meglio con Sedio.</Editable>
        <div className="mt-12">
          <Carousel opts={{ align: "start", loop: true }} className="w-full">
            <CarouselContent className="-ml-4">
              {TESTIMONIALS.map((t) => (
                <CarouselItem key={t.key} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <div className="card-soft h-full p-7">
                    <Stars />
                    <Editable as="p" path={`test.${t.key}.quote`} className="block text-sm leading-6 text-foreground">{t.quote}</Editable>
                    <div className="mt-5 flex items-center gap-3">
                      <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary"><BadgeCheck className="h-5 w-5" strokeWidth={2} /></span>
                      <div>
                        <p className="text-sm font-semibold text-foreground"><Editable path={`test.${t.key}.name`}>{t.name}</Editable></p>
                        <p className="text-xs text-muted-foreground"><Editable path={`test.${t.key}.role`}>{t.role}</Editable></p>
                      </div>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="mt-6 flex gap-2">
              <CarouselPrevious className="static translate-y-0" data-testid="testimonials-prev" />
              <CarouselNext className="static translate-y-0" data-testid="testimonials-next" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>
  );
};
